// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".distance_icon{\n    color: black;\n    font-weight: 700;\n    background-color: white;\n    text-align: center;\n    border-radius: 8px;\n}", ""]);
// Exports
module.exports = exports;
